import { render, staticRenderFns } from "./Customerordersetting.vue?vue&type=template&id=dca354d2&scoped=true&"
import script from "./Customerordersetting.vue?vue&type=script&lang=js&"
export * from "./Customerordersetting.vue?vue&type=script&lang=js&"
import style0 from "./Customerordersetting.vue?vue&type=style&index=0&id=dca354d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca354d2",
  null
  
)

export default component.exports